import Fab from "@mui/material/Fab";
import makeStyles from "@mui/styles/makeStyles";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SomuraTooltip from "Components/SomuraTooltip";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "1rem",
    position: "relative",
    marginRight: "4px"
  },
}));

const RefreshButton = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <SomuraTooltip title={t("Refresh")} placement="top" arrow={true}>
      <Fab
        variant="extended"
        color="primary"
        size="medium"
        className={classes.root}
        onClick={props.onClick}
      >
        <AutorenewIcon />
      </Fab>
    </SomuraTooltip>
  );
};

export default RefreshButton;
